<script>
  import { fade } from "svelte/transition";
</script>

<div
  class="w-full pt-4 overflow-hidden border rounded border-neutral-3"
  transition:fade={{ duration: 300 }}
>
  <slot />
</div>

<style></style>
